export default class Segment {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): Segment {
    return new Segment(obj || {});
  }

  public static ofList(obj: any[]): Segment[] {
    return obj.map(this.of);
  }
}
